import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardEditOrgRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardEditOrgPageLoadable } from './OrgDashboardEditOrgPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardEditOrgRoute>,
) {
  await OrgDashboardEditOrgPageLoadable.load();
}

export default function OrgDashboardEditOrgHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardEditOrgPageLoadable />;
}
